<ng-container *ngTemplateOutlet="isExternalLink ? external : internal">
</ng-container>

<ng-template #external>
    <a target="_blank" class="nsw-small nsw-link nsw-link--icon" *ngIf="!safeUrl()" href="javascript:void(0)" [attr.download]="download ? '' : null">
        <span class="label">{{text}}</span>
        <i class="material-icons nsw-material-icons" focusable="false" aria-hidden="true">launch</i>
    </a>
    <a target="_blank" class="nsw-small nsw-link nsw-link--icon" *ngIf="link" [href]="safeUrl()" [attr.download]="download ? '' : null">
        <span class="label">{{text}}</span>
        <i class="material-icons nsw-material-icons" focusable="false" aria-hidden="true">launch</i>
    </a>
</ng-template>

<ng-template #internal>
    <a class="nsw-small nsw-link nsw-link--icon" *ngIf="!safeUrl()" href="javascript:void(0)" [attr.download]="download ? '' : null">
        <span class="label">{{text}}</span>
        <i class="material-icons nsw-material-icons" focusable="false" aria-hidden="true">launch</i>
    </a>
    <a class="nsw-small nsw-link nsw-link--icon" *ngIf="safeUrl()" [routerLink]="safeUrl()" [attr.download]="download ? '' : null">
        <span class="label">{{text}}</span>
        <i class="material-icons nsw-material-icons" focusable="false" aria-hidden="true">launch</i>
    </a>    
</ng-template>

